export default class SessionStorage {
  static get(attribute) {
    return localStorage.getItem(attribute);
  }

  static add(attribute, data) {
    localStorage.setItem(attribute, data);
  }

  static remove(attribute) {
    localStorage.removeItem(attribute);
  }
}
